import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CisProSearchRequest {
  materialName?: string;
  productDescription?: string;
  labelName?: string;
  manufacturer?: string;
  serviceCompany?: string;
  rigName?: string;
  location?: string;
  barcodeId?: string;
  notes?: string;
  receivedFrom?: Date | null;
  receivedTo?: Date | null;
  showOwnedLocationsOnly: boolean;
}

export interface CisProSearchResult {
  barcodeId: string;
  materialName: string;
  physicalDescription: string;
  specificGravity: number;
  netQuantity: number;
  unitOfMeasureName: string;
  notes: string;
  location: string;
  manufacturer: string;
  receivedDate?: Date | null;
  productDescription?: string;
  serviceCompany?: string;
  rigName?: string;
  isDeleted: boolean;
  labelName?: string;
  lotNumber: string;
}

interface SampleManagerSearchRequest {
  materialName?: string;
  productDescription?: string;
  labelName?: string;
  manufacturer?: string;
  serviceCompany?: string;
  rigName?: string;
  location?: string;
  barcodeId?: string;
  notes?: string;
  receivedDate: {
    from?: Date | null;
    to?: Date | null;
  };
  showOwnedLocationsOnly: boolean;
}

@Injectable({ providedIn: 'root' })
export class CisProSearchService {
  private apiUrl = `${environment.apiUrl}/tools`;

  constructor(private http: HttpClient) {}

  searchContainers(request: CisProSearchRequest): Observable<CisProSearchResult[]> {
    const sampleManagerRequest: SampleManagerSearchRequest = {
      materialName: request.materialName,
      productDescription: request.productDescription,
      labelName: request.labelName,
      manufacturer: request.manufacturer,
      serviceCompany: request.serviceCompany,
      rigName: request.rigName,
      location: request.location,
      barcodeId: request.barcodeId,
      notes: request.notes,
      receivedDate: {
        from: request.receivedFrom,
        to: request.receivedTo
      },
      showOwnedLocationsOnly: request.showOwnedLocationsOnly
    };

    return this.http.post<CisProSearchResult[]>(`${this.apiUrl}/search/cispro`, sampleManagerRequest);
  }
}
